import { Component, OnInit, Input } from '@angular/core';

import { File } from 'app/models/file';
import { FileType } from 'app/models/file-type.enum';
import { FileIconType } from 'app/models/file-icon-type.enum';
import { Router, ActivatedRoute } from '@angular/router';
import { SharepointService } from 'app/services/sharepoint.service';
import { Optional, Output, EventEmitter } from '@angular/core';
import { CompetitionService } from 'app/services/competition.service';

@Component({
  selector: 'app-document-item',
  templateUrl: './document-item.component.html',
  styleUrls: ['./document-item.component.scss']
})
export class DocumentItemComponent implements OnInit {
  @Output() deleted = new EventEmitter<string>();
  @Input() file: File;
  public fileIconType: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private competitionService: CompetitionService,
    @Optional() private sharepointService?: SharepointService
  ) {}  

  ngOnInit() {
    this.fileIconType = `icon-${FileIconType[this.enumRrverse(FileType,
      this.file.contentType || this.file.source)]}`;
  }

  enumRrverse(enumList, value) {
    const keys = Object.keys(enumList).filter(k => typeof enumList[k as any] === 'string');
    const values = keys.filter(k => enumList[k as any] === value);
    return values[0];
  }

  onSelect() {
    const compUrl = this.competitionService.getCompetitionUrl();
    if (compUrl) {
      this.router.navigate(['/admin/competition', compUrl, 'file', this.file.id]);
    } else {
      this.router.navigate(
        ['file', this.file.id],
        { relativeTo: this.activatedRoute }
      );
    }
  }

  onDelete(file?: any) {
    const confirmed = window.confirm(`Are you sure you want to delete "${this.file.displayName}"?`);
    if (!confirmed) return;
  
    if (!this.sharepointService) {
      console.warn('SharepointService is not provided. Skipping deletion.');
      return;
    }
  
    this.sharepointService.deleteFile(this.file.id).subscribe({
      next: () => {
        this.deleted.emit(this.file.id);
      },
      error: (err) => {
        console.error('Error deleting file:', err);
        alert('Failed to delete the file.');
      }
    });
  }
}
